import React from "react";
import * as Muicon from "@mui/icons-material";

const CustomIconComponent = ({ iconName = "", fontSize = 30, color="inherit" }) => {
  const Icon = Muicon[iconName];
  if(!iconName) return null
  return <Icon sx={{ fontSize }} color={color} />;
};
export default CustomIconComponent;
